import { css } from '@emotion/react'

export const styles = css`
  .rc-tree-select {
    font-size: 12px;
    overflow: hidden;
    background: #fff;
    position: absolute;
    border: 1px solid #d9d9d9;
    border-radius: var(--button-border-radius);
    white-space: nowrap;

    box-sizing: border-box;
    display: inline-block;
    position: relative;
    vertical-align: middle;
    color: #666;
  }
  .rc-tree-select-selector {
    width: 100% !important;
    height: 100%;
    padding: 0 12px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .rc-tree-select-selection-overflow {
    width: 100% !important;
    height: 32px;
    display: flex;
    align-items: center;
    overflow: hidden;
    justify-content: start;
  }
  .rc-tree-select-single .rc-tree-select-selector {
    display: flex;
    position: relative;
    justify-content: flex-start;
    align-items: center;
    height: 100%;
    z-index: 1;
  }
  .rc-tree-select-selection-overflow-item-suffix {
    width: 100%;
  }
  .rc-tree-select-selection-overflow-item {
    float: right;
  }

  .rc-tree-select-single:not(.rc-tree-select-customize-input)
    .rc-tree-select-selector
    .rc-tree-select-selection-search-input {
    border: none;
    outline: none;
    width: 100%;
  }
  .rc-tree-select-single
    .rc-tree-select-selector
    .rc-tree-select-selection-item,
  .rc-tree-select-single
    .rc-tree-select-selector
    .rc-tree-select-selection-placeholder {
    position: absolute !important;
    left: 12px;
    font-size: 0.8125rem;
    color: var(--ow-color-gray-300);
    pointer-events: none;
  }
  .input-group .rc-tree-select-selection-placeholder {
    left: 2px !important;
  }
  .rc-tree-select-selection-search-mirror {
    display: none;
  }

  .rc-tree-select-multiple .rc-tree-select-selection-overflow {
    flex-wrap: nowrap;
  }
  .rc-tree-select-multiple
    .rc-tree-select-selector
    .rc-tree-select-selection-placeholder {
    position: absolute !important;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
  }

  .rc-tree-select-allow-clear .rc-tree-select-clear {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
  }

  .rc-tree-select-selection-item {
    background-color: hsl(0, 0%, 90%);
    white-space: nowrap;
    border-radius: 2px;
    margin: 0 2px;
    padding: 2px;
    .rc-tree-select-selection-item-content {
      padding: 3px;
      font-size: 12px;
    }
  }
  .rc-tree-select-selection-search {
    display: flex;
    height: 100%;
    width: 90% !important;
  }
  .rc-tree-select-tree-node-content-wrapper {
    cursor: pointer !important;
    display: flex;
    align-items: center;
    /* max-width: 120px; */
  }
  .rc-tree-select-selection-search-input {
    outline: none;
    border: none;
    width: 100%;
  }
  .rc-tree-select-tree {
    margin: 0;
    padding: 5px;
    display: block;
  }
  .rc-tree-select-tree li {
    padding: 0;
    margin: 0;
    list-style: none;
    white-space: nowrap;
    outline: 0;
  }
  .rc-tree-select-tree li a[draggable],
  .rc-tree-select-tree li a[draggable='true'] {
    color: #333;
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    /* Required to make elements draggable in old WebKit */
    -khtml-user-drag: element;
    -webkit-user-drag: element;
  }
  .rc-tree-select-tree li.drag-over > a[draggable] {
    background-color: #316ac5;
    color: white;
    border: 1px #316ac5 solid;
    opacity: 0.8;
  }
  .rc-tree-select-tree li.drag-over-gap-top > a[draggable] {
    border-top: 2px blue solid;
  }
  .rc-tree-select-tree li.drag-over-gap-bottom > a[draggable] {
    border-bottom: 2px blue solid;
  }
  .rc-tree-select-tree .filter-node {
    color: steelblue !important;
    font-weight: bold !important;
  }
  .rc-tree-select-tree
    li.filter-node
    > .rc-tree-select-tree-node-content-wrapper {
    color: steelblue !important;
    font-weight: bold !important;
  }
  .rc-tree-select-tree li ul {
    margin: 0;
    padding: 0 0 0 18px;
  }
  .rc-tree-select-tree li ul.rc-tree-select-tree-line {
    background: url('data:image/gif;base64,R0lGODlhCQACAIAAAMzMzP///yH5BAEAAAEALAAAAAAJAAIAAAIEjI9pUAA7')
      0 0 repeat-y;
  }
  .rc-tree-select-tree li a {
    display: inline-block;
    padding: 1px 3px 0 0;
    margin: 0;
    cursor: pointer;
    height: 17px;
    text-decoration: none;
    vertical-align: top;
  }
  .rc-tree-select-tree-switcher-noop {
    padding-left: 16px;
  }
  .rc-tree-select-tree li span.rc-tree-select-tree-iconEle {
    line-height: 16px;
    margin-right: 2px;
    width: 16px;
    height: 16px;
    display: inline-block;
    vertical-align: middle;
    border: 0 none;
    cursor: pointer;
    outline: none;
    background-color: transparent;
    background-repeat: no-repeat;
    background-attachment: scroll;
    background-image: url('data:image/png;base64,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');
  }
  .rc-tree-select-tree li span.rc-tree-select-tree-icon_loading {
    margin-right: 2px;
    vertical-align: top;
    background: url('data:image/gif;base64,R0lGODlhEAAQAKIGAMLY8YSx5HOm4Mjc88/g9Ofw+v///wAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFCgAGACwAAAAAEAAQAAADMGi6RbUwGjKIXCAA016PgRBElAVlG/RdLOO0X9nK61W39qvqiwz5Ls/rRqrggsdkAgAh+QQFCgAGACwCAAAABwAFAAADD2hqELAmiFBIYY4MAutdCQAh+QQFCgAGACwGAAAABwAFAAADD1hU1kaDOKMYCGAGEeYFCQAh+QQFCgAGACwKAAIABQAHAAADEFhUZjSkKdZqBQG0IELDQAIAIfkEBQoABgAsCgAGAAUABwAAAxBoVlRKgyjmlAIBqCDCzUoCACH5BAUKAAYALAYACgAHAAUAAAMPaGpFtYYMAgJgLogA610JACH5BAUKAAYALAIACgAHAAUAAAMPCAHWFiI4o1ghZZJB5i0JACH5BAUKAAYALAAABgAFAAcAAAMQCAFmIaEp1motpDQySMNFAgA7')
      no-repeat scroll 0 0 transparent;
  }
  .rc-tree-select-tree li span.rc-tree-select-tree-switcher-noop {
    cursor: auto;
    background: none;
  }
  .rc-tree-select-tree li span.rc-tree-select-tree-switcher_open {
    background-position: -93px -56px;
  }
  .rc-tree-select-tree-treenode {
    margin: 0;
    padding: 0;
    line-height: 30px;
    white-space: nowrap;
    list-style: none;
    outline: 0;
    color: #526484;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .rc-tree-select-tree-title {
    display: inline-block;
    font-size: 13px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .rc-tree-select-tree
    rc-tree-select-tree-treenode
    span.rc-tree-select-tree-switcher_close {
    background-position: -75px -56px;
  }
  .rc-tree-select-tree li span.rc-tree-select-tree-checkbox-checked {
    background-position: -14px 0;
  }
  .rc-tree-select-tree li span.rc-tree-select-tree-checkbox-indeterminate {
    background-position: -14px -28px;
  }
  .rc-tree-select-tree li span.rc-tree-select-tree-checkbox-disabled {
    background-position: 0 -56px;
  }
  .rc-tree-select-tree
    li
    span.rc-tree-select-tree-checkbox.rc-tree-select-tree-checkbox-checked.rc-tree-select-tree-checkbox-disabled {
    background-position: -14px -56px;
  }
  .rc-tree-select-tree
    li
    span.rc-tree-select-tree-checkbox.rc-tree-select-tree-checkbox-indeterminate.rc-tree-select-tree-checkbox-disabled {
    position: relative;
    background: #ccc;
    border-radius: 3px;
  }
  .rc-tree-select-tree
    li
    span.rc-tree-select-tree-checkbox.rc-tree-select-tree-checkbox-indeterminate.rc-tree-select-tree-checkbox-disabled::after {
    content: ' ';
    -webkit-transform: scale(1);
    transform: scale(1);
    position: absolute;
    left: 3px;
    top: 5px;
    width: 5px;
    height: 0;
    border: 2px solid #fff;
    border-top: 0;
    border-left: 0;
  }
  .rc-tree-select-tree-child-tree {
    display: none;
  }
  .rc-tree-select-tree-child-tree-open {
    display: block;
  }
  .rc-tree-select-tree-treenode-disabled > span,
  .rc-tree-select-tree-treenode-disabled > a,
  .rc-tree-select-tree-treenode-disabled > a span {
    color: #ccc;
    cursor: not-allowed;
  }
  .rc-tree-select-tree-indent {
    .rc-tree-select-tree-indent-unit {
      display: inline-block;
      width: 16px;
    }
  }

  .rc-tree-select-tree-icon__open {
    margin-right: 2px;
    background-position: -110px -16px;
    vertical-align: top;
  }
  .rc-tree-select-tree-icon__close {
    margin-right: 2px;
    background-position: -110px 0;
    vertical-align: top;
  }

  .rc-tree-select-allow-clear
    .rc-tree-select-selection--single
    .rc-tree-select-selection__rendered {
    padding-right: 40px;
  }
  .rc-tree-select ul,
  .rc-tree-select li {
    margin: 0;
    padding: 0;
    list-style: none;
  }
  .rc-tree-select > ul > li > a {
    padding: 0;
    background-color: #fff;
  }
  .rc-tree-select-arrow {
    height: 100%;
    position: absolute;
    top: 50%;
    right: 4px;
    transform: translateY(-50%);
    width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .rc-tree-select-arrow:after {
    content: '';
    border-color: #999999 transparent transparent transparent;
    border-style: solid;
    border-width: 5px 4px 0 4px;
    height: 0;
    width: 0;
    margin-left: -4px;
    margin-top: -2px;
    position: absolute;
    top: 50%;
    left: 50%;
    display: none;
  }
  .rc-tree-select-selection {
    outline: none;
    user-select: none;
    -webkit-user-select: none;
    box-sizing: border-box;
    display: block;
    background-color: #fff;
    border-radius: 6px;
    border: 1px solid #d9d9d9;
  }
  .rc-tree-select-selection__clear {
    font-weight: bold;
    position: absolute;
  }
  .rc-tree-select-enabled .rc-tree-select-selection:hover {
    border-color: #23c0fa;
    box-shadow: 0 0 2px rgba(45, 183, 245, 0.8);
  }
  .rc-tree-select-enabled .rc-tree-select-selection:active {
    border-color: #2db7f5;
  }
  .rc-tree-select-enabled.rc-tree-select-focused .rc-tree-select-selection {
    border-color: #7700fa;
    box-shadow: 0 0 2px rgba(45, 183, 245, 0.8);
  }
  .rc-tree-select-selection--single {
    height: 28px;
    cursor: pointer;
    position: relative;
  }
  .rc-tree-select-selection--single .rc-tree-select-selection__rendered {
    display: block;
    padding-left: 10px;
    padding-right: 20px;
    line-height: 28px;
  }
  .rc-tree-select-selection--single .rc-tree-select-selection-selected-value {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .rc-tree-select-selection--single .rc-tree-select-selection__clear {
    top: 5px;
    right: 20px;
  }
  .rc-tree-select-selection--single .rc-tree-select-selection__clear:after {
    content: '×';
  }
  .rc-tree-select-disabled {
    color: #ccc;
    cursor: not-allowed;
  }
  .rc-tree-select-disabled .rc-tree-select-selection--single,
  .rc-tree-select-disabled .rc-tree-select-selection__choice__remove {
    cursor: not-allowed;
    color: #ccc;
  }
  .rc-tree-select-disabled .rc-tree-select-selection--single:hover,
  .rc-tree-select-disabled .rc-tree-select-selection__choice__remove:hover {
    cursor: not-allowed;
    color: #ccc;
  }
  .rc-tree-select-search__field__wrap {
    display: inline-block;
    position: relative;
  }
  .rc-tree-select-search__field__placeholder {
    display: block;
    position: absolute;
    top: 0;
    left: 3px;
    color: #aaa;
  }
  .rc-tree-select-search__field__mirror {
    position: absolute;
    top: 0;
    left: -9999px;
    white-space: pre;
    pointer-events: none;
  }
  .rc-tree-select-search--inline {
    float: left;
    width: 100%;
  }
  .rc-tree-select-search--inline .rc-tree-select-search__field__wrap {
    width: 100%;
  }
  .rc-tree-select-search--inline .rc-tree-select-search__field {
    border: none;
    font-size: 100%;
    background: transparent;
    outline: 0;
    width: 100%;
  }
  .rc-tree-select-search--inline > i {
    float: right;
  }
  .rc-tree-select-enabled.rc-tree-select-selection--multiple {
    cursor: text;
  }
  .rc-tree-select-selection--multiple {
    min-height: 28px;
  }
  .rc-tree-select-selection--multiple .rc-tree-select-search--inline {
    width: auto;
  }
  .rc-tree-select-selection--multiple
    .rc-tree-select-search--inline
    .rc-tree-select-search__field {
    width: 0.75em;
  }
  .rc-tree-select-selection--multiple
    .rc-tree-select-search__field__placeholder {
    top: 5px;
    left: 8px;
  }

  .rc-tree-select-selection--multiple
    .rc-tree-select-search__field__placeholder {
    top: 5px;
    left: 8px;
  }
  .rc-tree-select-selection--multiple .rc-tree-select-selection__rendered {
    overflow: hidden;
    text-overflow: ellipsis;
    padding-left: 8px;
    padding-bottom: 2px;
    padding-right: 10px;
  }
  .rc-tree-select-selection--multiple > ul > li {
    margin-top: 4px;
    height: 20px;
    line-height: 20px;
  }
  .rc-tree-select-selection--multiple .rc-tree-select-selection__clear {
    top: 5px;
    right: 8px;
  }
  .rc-tree-select-enabled .rc-tree-select-selection__choice {
    cursor: default;
  }
  .rc-tree-select-enabled
    .rc-tree-select-selection__choice:hover
    .rc-tree-select-selection__choice__remove {
    opacity: 1;
    transform: scale(1);
  }
  .rc-tree-select-enabled
    .rc-tree-select-selection__choice:hover
    .rc-tree-select-selection__choice__remove
    + .rc-tree-select-selection__choice__content {
    margin-left: -8px;
    margin-right: 8px;
  }
  .rc-tree-select .rc-tree-select-selection__choice {
    background-color: #f3f3f3;
    border-radius: var(--button-border-radius);
    float: left;
    padding: 0 15px;
    margin-right: 4px;
    position: relative;
    overflow: hidden;
    transition: padding 0.3s cubic-bezier(0.6, -0.28, 0.735, 0.045),
      width 0.3s cubic-bezier(0.6, -0.28, 0.735, 0.045);
  }
  .rc-tree-select .rc-tree-select-selection__choice__content {
    margin-left: 0;
    margin-right: 0;
    transition: margin 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  }
  .rc-tree-select .rc-tree-select-selection__choice-zoom-enter,
  .rc-tree-select .rc-tree-select-selection__choice-zoom-appear,
  .rc-tree-select .rc-tree-select-selection__choice-zoom-leave {
    animation-duration: 0.3s;
    animation-fill-mode: both;
    transform-origin: 0 0;
    opacity: 0;
    animation-play-state: paused;
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
  }
  .rc-tree-select .rc-tree-select-selection__choice-zoom-leave {
    opacity: 1;
    animation-timing-function: cubic-bezier(0.6, -0.28, 0.735, 0.045);
  }
  .rc-tree-select
    .rc-tree-select-selection__choice-zoom-enter.rc-tree-select-selection__choice-zoom-enter-active,
  .rc-tree-select
    .rc-tree-select-selection__choice-zoom-appear.rc-tree-select-selection__choice-zoom-appear-active {
    animation-play-state: running;
    animation-name: rcSelectChoiceZoomIn;
  }
  .rc-tree-select
    .rc-tree-select-selection__choice-zoom-leave.rc-tree-select-selection__choice-zoom-leave-active {
    animation-play-state: running;
    animation-name: rcSelectChoiceZoomOut;
  }
  @keyframes rcSelectChoiceZoomIn {
    0% {
      transform: scale(0.6);
      opacity: 0;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
  @keyframes rcSelectChoiceZoomOut {
    to {
      transform: scale(0);
      opacity: 0;
    }
  }
  .rc-tree-select .rc-tree-select-selection__choice__remove {
    color: #919191;
    cursor: pointer;
    font-weight: bold;
    padding: 0 0 0 8px;
    position: absolute;
    opacity: 0;
    transform: scale(0);
    top: 0;
    right: 2px;
    transition: opacity 0.3s, transform 0.3s;
  }
  .rc-tree-select .rc-tree-select-selection__choice__remove:before {
    content: '×';
  }
  .rc-tree-select .rc-tree-select-selection__choice__remove:hover {
    color: #333;
  }
  .rc-tree-select-dropdown {
    background-color: white;
    border: 1px solid #d9d9d9;
    box-shadow: 0 0px 4px #d9d9d9;
    border-radius: var(--button-border-radius);
    box-sizing: border-box;
    z-index: 100;
    left: -9999px;
    top: -9999px;
    position: absolute;
    outline: none;
    z-index: 1000;
  }
  .rc-tree-select-dropdown-hidden {
    display: none;
  }
  .rc-tree-select-dropdown-menu {
    outline: none;
    margin: 0;
    padding: 0;
    list-style: none;
    z-index: 9999;
  }
  .rc-tree-select-dropdown-menu > li {
    margin: 0;
    padding: 0;
  }
  .rc-tree-select-dropdown-menu-item-group-list {
    margin: 0;
    padding: 0;
  }
  .rc-tree-select-dropdown-menu-item-group-list > li.rc-tree-select-menu-item {
    padding-left: 20px;
  }
  .rc-tree-select-dropdown-menu-item-group-title {
    color: #999;
    line-height: 1.5;
    padding: 8px 10px;
    border-bottom: 1px solid #dedede;
  }
  li.rc-tree-select-dropdown-menu-item {
    margin: 0;
    position: relative;
    display: block;
    padding: 7px 10px;
    font-weight: normal;
    color: #666666;
    white-space: nowrap;
  }
  li.rc-tree-select-dropdown-menu-item-selected {
    background-color: #ddd;
  }
  li.rc-tree-select-dropdown-menu-item-active {
    background-color: var(--ow-color-primary-600);
    color: white;
    cursor: pointer;
  }
  li.rc-tree-select-dropdown-menu-item-disabled {
    color: #ccc;
    cursor: not-allowed;
  }
  li.rc-tree-select-dropdown-menu-item-divider {
    height: 1px;
    margin: 1px 0;
    overflow: hidden;
    background-color: #e5e5e5;
    line-height: 0;
  }
  .rc-tree-select-dropdown-slide-up-enter,
  .rc-tree-select-dropdown-slide-up-appear {
    animation-duration: 0.3s;
    animation-fill-mode: both;
    transform-origin: 0 0;
    opacity: 0;
    animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
    animation-play-state: paused;
  }
  .rc-tree-select-dropdown-slide-up-leave {
    animation-duration: 0.3s;
    animation-fill-mode: both;
    transform-origin: 0 0;
    opacity: 1;
    animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);
    animation-play-state: paused;
  }
  .rc-tree-select-dropdown-slide-up-enter.rc-tree-select-dropdown-slide-up-enter-active.rc-tree-select-dropdown-placement-bottomLeft,
  .rc-tree-select-dropdown-slide-up-appear.rc-tree-select-dropdown-slide-up-appear-active.rc-tree-select-dropdown-placement-bottomLeft {
    animation-name: rcSelectDropdownSlideUpIn;
    animation-play-state: running;
  }
  .rc-tree-select-dropdown-slide-up-leave.rc-tree-select-dropdown-slide-up-leave-active.rc-tree-select-dropdown-placement-bottomLeft {
    animation-name: rcSelectDropdownSlideUpOut;
    animation-play-state: running;
  }
  .rc-tree-select-dropdown-slide-up-enter.rc-tree-select-dropdown-slide-up-enter-active.rc-tree-select-dropdown-placement-topLeft,
  .rc-tree-select-dropdown-slide-up-appear.rc-tree-select-dropdown-slide-up-appear-active.rc-tree-select-dropdown-placement-topLeft {
    animation-name: rcSelectDropdownSlideDownIn;
    animation-play-state: running;
  }
  .rc-tree-select-dropdown-slide-up-leave.rc-tree-select-dropdown-slide-up-leave-active.rc-tree-select-dropdown-placement-topLeft {
    animation-name: rcSelectDropdownSlideDownOut;
    animation-play-state: running;
  }
  @keyframes rcSelectDropdownSlideUpIn {
    0% {
      opacity: 0;
      transform-origin: 0% 0%;
      transform: scaleY(0);
    }
    100% {
      opacity: 1;
      transform-origin: 0% 0%;
      transform: scaleY(1);
    }
  }
  @keyframes rcSelectDropdownSlideUpOut {
    0% {
      opacity: 1;
      transform-origin: 0% 0%;
      transform: scaleY(1);
    }
    100% {
      opacity: 0;
      transform-origin: 0% 0%;
      transform: scaleY(0);
    }
  }
  @keyframes rcSelectDropdownSlideDownIn {
    0% {
      opacity: 0;
      transform-origin: 0% 100%;
      transform: scaleY(0);
    }
    100% {
      opacity: 1;
      transform-origin: 0% 100%;
      transform: scaleY(1);
    }
  }
  @keyframes rcSelectDropdownSlideDownOut {
    0% {
      opacity: 1;
      transform-origin: 0% 100%;
      transform: scaleY(1);
    }
    100% {
      opacity: 0;
      transform-origin: 0% 100%;
      transform: scaleY(0);
    }
  }
  .rc-tree-select-dropdown-search {
    display: block;
    padding: 4px;
  }
  .rc-tree-select-dropdown-search .rc-tree-select-search__field__wrap {
    width: 100%;
  }
  .rc-tree-select-dropdown-search .rc-tree-select-search__field__placeholder {
    top: 4px;
  }
  .rc-tree-select-dropdown-search .rc-tree-select-search__field {
    padding: 4px;
    width: 100%;
    box-sizing: border-box;
    border: 1px solid #d9d9d9;
    border-radius: var(--button-border-radius);
    outline: none;
  }
  .rc-tree-select-dropdown-search.rc-tree-select-search--hide {
    display: none;
  }
  .rc-tree-select-open .rc-tree-select-arrow:after {
    display: none;
    border-color: transparent transparent #888 transparent;
    border-width: 0 4px 5px 4px;
  }
  .rc-tree-select-open .icon-chevron-down {
    transform: rotatex(180deg);
  }
  .rc-tree-select-not-found {
    display: inline-block;
    padding: 8px;
  }
  .custom-icon-demo .rc-tree-select-selection__choice__remove:before {
    content: '';
  }
  .custom-icon-demo .rc-tree-select-arrow:after {
    display: none;
  }
  .custom-icon-demo .rc-tree-select-selection__clear:after {
    content: '';
  }
  .rc-tree-select-tree-switcher,
  .rc-tree-select-tree-checkbox {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: 2px;
    line-height: 16px;
    vertical-align: -0.125em;
    background-color: transparent;
    background-image: url('data:image/png;base64,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');
    background-repeat: no-repeat;
    background-attachment: scroll;
    border: 0 none;
    outline: none;
    cursor: pointer;
    flex-shrink: 0;
  }
  .rc-tree-select-tree-switcher_open {
    background-position: -41.7px -9px;
  }

  .rc-tree-select-tree-switcher_close {
    background-position: -10px -9px;
  }
  .rc-tree-select-tree-checkbox {
    width: 20px;
    height: 22px;
    margin: 0 3px;
    background-position: -165px -4px;
  }
  .rc-tree-select-tree-checkbox-checked {
    background-position: -229px -4px;
  }
  .rc-tree-select-tree-switcher-noop {
    background-image: none;
  }
  .rc-tree-select-focused {
    border-color: var(--ow-color-primary-600);
    box-shadow: 0 0 0 3px var(--ow-color-primary-50);
  }
  .rc-tree-select-tree-node-selected {
    color: var(--ow-color-primary-600);
    background: var(--ow-color-primary-50);
    border-radius: var(--button-border-radius);
  }
`
